<template>
  <div>
    <h2 class="ViewHeading">{{ this.detailToShow }} Linked Devices Report</h2>
    <b-button variant="outline-secondary" size="sm" v-on:click="backButton()">
      <BIconArrowLeftSquare variant="dark"> </BIconArrowLeftSquare>
      Back
    </b-button>

    <b-spinner
      v-if="this.loading == true"
      style="width: 3rem; height: 3rem;"
      type="grow"
      label="Loading..."
      variant="info"
    ></b-spinner>
    <div v-if="this.loading == false">
      <b-card v-if="this.detailToShow == 'C-1'">
        <template #header
          ><h4>{{ headerText }}</h4>
        </template>
        <b-card v-if="this.LinkedList.length == 0"
          >Not Linked to any outlets</b-card
        >
        <div v-if="this.LinkedList.length != 0">
          <b-row>
            <b-col><b>Type</b></b-col>
            <b-col><b>ID</b></b-col>
          </b-row>
          <b-row v-for="item in this.LinkedList" :key="item.id">
            <b-col>{{ item.Type }}</b-col>
            <b-col>{{ item.ID }}</b-col>
          </b-row>
        </div>
        <br />
        <b-button
          variant="outline-info"
          v-b-toggle.OutletCollapse
          v-on:click="showEditList(LocalDeviceID, 'C-1', LinkedList)"
          size="sm"
        >
          Edit Links
        </b-button>
      </b-card>
      <b-card v-if="this.detailToShow == 'O-1'">
        <template #header
          ><h4>{{ headerText }}</h4>
        </template>
        <b-card v-if="this.LinkedList.length == 0"
          >Not Linked to any outlets</b-card
        >
        <div v-if="this.LinkedList.length != 0">
          <b-row>
            <b-col><b>Type</b></b-col>
            <b-col><b>ID</b></b-col>
          </b-row>
          <b-row v-for="item in this.LinkedList" :key="item.id">
            <b-col>{{ item.Type }}</b-col>
            <b-col>{{ item.ID }}</b-col>
          </b-row>
        </div>
        <br />
        <b-button
          variant="outline-info"
          v-b-toggle.OutletCollapse
          v-on:click="showEditList(LocalDeviceID, 'O-1', LinkedList)"
          size="sm"
        >
          Edit Links
        </b-button>
      </b-card>
      <b-card v-if="this.detailToShow == 'Outlet'">
        <template #header
          ><h4>{{ headerText }}</h4>
        </template>
        <b-card v-if="this.LinkedList.length == 0"
          >Not Linked to any outlets</b-card
        >
        <div v-if="this.LinkedList.length != 0">
          <b-row>
            <b-col><b>Type</b></b-col>
            <b-col><b>ID</b></b-col>
          </b-row>
          <b-row v-for="item in this.LinkedList" :key="item.id">
            <b-col>{{ item.Type }}</b-col>
            <b-col>{{ item.ID }}</b-col>
          </b-row>
        </div>
        <br />
        <b-button
          variant="outline-info"
          v-b-toggle.DeviceCollapse
          v-on:click="showEditList(LocalDeviceID, 'Outlet', LinkedList)"
          size="sm"
        >
          Edit Links
        </b-button>
      </b-card>
      <b-collapse id="OutletCollapse" class="mt-2">
        <b-card>
          <b-table
            sticky-header
            id="OutletTable"
            :items="OutletItems"
            no-border-collapse
            hover
            show-empty
            empty-text="You currently dont have any outlets of this type"
            responsive
            small
          >
            <template v-slot:cell(LinkedDevice)="{ item }">
              <b-form-checkbox
                :id="item.ID"
                v-model="item.LinkedDevice"
                name="checkbox-1"
                value="TRUE"
                unchecked-value="FALSE"
              >
              </b-form-checkbox>
            </template>
          </b-table>
          <b-button
            variant="outline-info"
            v-on:click="SubmiteEditedList(OutletItems, LocalDeviceID)"
            >Submit</b-button
          >
          <b-button
            variant="outline-info"
            v-b-toggle.OutletCollapse
            v-on:click="CancelEdit('Outlet')"
            >Cancel</b-button
          >
        </b-card>
      </b-collapse>
      <b-collapse id="DeviceCollapse" class="mt-2">
        <b-card>
          <b-table
            sticky-header
            id="DeviceTable"
            :items="DeviceItems"
            no-border-collapse
            hover
            show-empty
            empty-text="You currently dont have any Devices of this type"
            responsive
            small
          >
            <template v-slot:cell(LinkedDevice)="{ item }">
              <b-form-checkbox
                :id="item.ID"
                v-model="item.LinkedDevice"
                name="checkbox-1"
                value="TRUE"
                unchecked-value="FALSE"
              >
              </b-form-checkbox>
            </template>
          </b-table>
          <b-button
            variant="outline-info"
            v-on:click="SubmiteEditedList(DeviceItems, LocalDeviceID)"
            >Submit</b-button
          >
          <b-button
            variant="outline-info"
            v-b-toggle.DeviceCollapse
            v-on:click="CancelEdit('Device')"
            >Cancel</b-button
          >
        </b-card>
      </b-collapse>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { BIconArrowLeftSquare } from "bootstrap-vue";

export default {
  computed: {},
  components: {
    BIconArrowLeftSquare,
  },
  data() {
    return {
      detailToShow: this.$DetailToShow,
      LocalDeviceID: this.$DeviceID,
      loading: false,
      headerText: "",
      LinkedList: [],
      selectedlocation: localStorage.getItem("CurrentLocation"),
      selected: [],
      OutletItems: [],
      DeviceItems: [],
      OutletArray: [],
      DeviceArray: [],
      Inlist: "",
      EditedLinkedList: [],
      EditedID: "",
      EditedType: "",
    };
  },
  mounted() {
    let LookUpUrlOut =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersOut = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "DeviceLinks",
      DeviceID: this.$DeviceID,
    };

    axios
      .post(LookUpUrlOut, this.LookUpRequest, LookUpHeadersOut)
      .then((response) => {
        this.LinkedList = [];
        let ListArray = response.data.Values;

        for (let i = 0; i < ListArray.length; i++) {
          this.LinkedList.push({
            ID: ListArray[i].ID,
            Type: ListArray[i].Type,
          });
        }
      });

    if (this.detailToShow == "C-1" || this.detailToShow == "O-1") {
      this.headerText =
        "" + this.detailToShow + " Device: " + this.LocalDeviceID;
      this.loading = false;
    }
    if (this.detailToShow == "Outlet") {
      this.headerText = "Outlet: " + this.LocalDeviceID;
      this.loading = false;
    }
  },
  methods: {
    showEditList(id, type, list) {
      if (type == "Outlet") {
        let TempList = list;

        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/locations";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "ClarenceDeviceLocation",
          LocationDict: [
            {
              Location: this.selectedlocation,
              FilterType: "",
              Feed: "",
              State: "",
            },
          ],
        };

        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            let DeviceArray = response.data.Values;
            let newInList = "";

            for (let i = 0; i < DeviceArray.length; i++) {
              for (let u = 0; u < TempList.length; u++) {
                if (TempList[u].ID == DeviceArray[i][0]) {
                  newInList = "TRUE";
                  break;
                } else {
                  newInList = "FALSE";
                }
              }

              if (TempList.length == 0) {
                newInList = "FALSE";
              }

              this.DeviceItems.push({
                ID: DeviceArray[i][0],
                Type: DeviceArray[i][8],
                RoomArea: DeviceArray[i][1],
                Position: DeviceArray[i][3],
                LinkedDevice: newInList,
              });
            }
          });
      }
      if (type == "C-1" || type == "O-1") {
        let TempList = list;

        let LookUpUrlOut =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/locations";
        let LookUpHeadersOut = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "OutletLocation",
          LocationDict: [
            {
              Location: this.selectedlocation,
              FilterType: "",
              Type: "",
            },
          ],
        };

        axios
          .post(LookUpUrlOut, this.LookUpRequest, LookUpHeadersOut)
          .then((response) => {
            let OutletArray = response.data.Values;
            let newInList = "";

            for (let i = 0; i < OutletArray.length; i++) {
              for (let u = 0; u < TempList.length; u++) {
                if (TempList[u].ID == OutletArray[i][0]) {
                  newInList = "TRUE";
                  break;
                } else {
                  newInList = "FALSE";
                }
              }

              if (TempList.length == 0) {
                newInList = "FALSE";
              }

              this.OutletItems.push({
                ID: OutletArray[i][0],
                Type: OutletArray[i][1],
                RoomArea: OutletArray[i][3],
                Position: OutletArray[i][6],
                LinkedDevice: newInList,
              });
            }
          });
      }
    },
    backButton() {
      history.back();
    },

    CancelEdit(type) {
      if (type == "Device") {
        (this.DeviceArray = []), (this.DeviceItems = []);
      }
      if (type == "Outlet") {
        (this.OutletArray = []), (this.OutletItems = []);
      }
    },

    SubmiteEditedList(list, id) {
      this.EditedLinkedList = [];
      let TypeVar = "";

      for (let i = 0; i < list.length; i++) {
        if (list[i].LinkedDevice == "TRUE") {
          if (list[i].Type == "C-1" || list[i].Type == "O-1") {
            TypeVar = list[i].Type;
          } else {
            TypeVar = "Outlet";
          }

          this.EditedLinkedList.push({
            ID: list[i].ID,
            Type: TypeVar,
          });
        }
      }

      let ListPostURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/device";
      let ListPostHeaders = this.$apikeyPost;
      this.ListPostRequest = {
        RequestType: "ModifyDeviceLinks",
        DeviceDict: [
          {
            DeviceID: id,
            DeviceLinks: this.EditedLinkedList,
          },
        ],
      };

      axios
        .post(ListPostURL, this.ListPostRequest, ListPostHeaders)
        .then((response) => {
          response;

          if (this.detailToShow == "C-1" || this.detailToShow == "O-1") {
            (this.DeviceArray = []),
              (this.DeviceItems = []),
              this.$root.$emit("bv::toggle::collapse", "OutletCollapse");
          }

          if (this.detailToShow == "Outlet") {
            (this.OutletArray = []),
              (this.OutletItems = []),
              this.$root.$emit("bv::toggle::collapse", "DeviceCollapse");
          }
          alert("Edited Linked List submitted successfully");
          this.TableRefresh();
        });
    },

    TableRefresh() {
      let LookUpUrlOut =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/lookup";
      let LookUpHeadersOut = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "DeviceLinks",
        DeviceID: this.$DeviceID,
      };

      axios
        .post(LookUpUrlOut, this.LookUpRequest, LookUpHeadersOut)
        .then((response) => {
          this.LinkedList = [];
          let ListArray = response.data.Values;

          for (let i = 0; i < ListArray.length; i++) {
            this.LinkedList.push({
              ID: ListArray[i].ID,
              Type: ListArray[i].Type,
            });
          }
        });
    },
  },
};
</script>
<style></style>
